import { Component, Input, OnInit } from '@angular/core';
import { TestHooks } from './loading.hooks';

@Component({
	selector: 'app-loading',
	templateUrl: './loading.component.html',
	standalone: false,
})
export class LoadingComponent implements OnInit {
	testHooks = TestHooks;
	@Input() text: string;
	@Input() opacity = '80';
	@Input() show: boolean;

	constructor() {}

	ngOnInit(): void {}
}
